import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Dialog, Form, Select } from 'tdesign-react';
import { createGeo } from '@/services/namespaceService';
import Tip from '@/components/Tip';
import Text from '@/components/Text';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function ModalForm({ visible, handleClose, geoList, namespace, clusters }) {
  const [submitting, setSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();

  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  const clusterName = searchParams.get('name');

  const options = useMemo(() => {
    return geoList
      ?.filter((item) => !clusters.includes(item))
      .map((item) => ({ label: item, value: item }));
  }, [geoList, clusters]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const parmas = {
          ...fields,
          clusterName,
        };
        await createGeo(parmas);
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  const doInit = useMemoizedFn(() => {
    form.setFields([{ name: 'namespace', value: namespace }]);
  });

  useEffect(() => {
    if (visible) {
      doInit();
    } else {
      form.reset();
    }
  }, [visible, form, doInit]);

  return (
    <Dialog
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='添加GEO集群'
      width={550}
      onClose={() => handleClose()}
    >
      <Form form={form} style={{ width: '90%' }} labelWidth={180} onSubmit={handleSubmit}>
        <FormItem label='命名空间' name='namespace'>
          <Text />
        </FormItem>
        <FormItem
          label={<Tip content='没找到，请到Cluster中GEO配置添加'>GEO集群</Tip>}
          name='replicationClusterName'
          rules={[{ required: true }]}
        >
          <Select options={toTsOptions(options)} />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  geoList: state.cluster.geoList,
}))(ModalForm);
